import type { ReactNode } from "react";
import { slugifyTitle, STATS_CARD_CLASS } from "./chartTheme";

export interface StatsCardProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function StatsCard({ title, subtitle, action, children, className = "" }: StatsCardProps) {
  return (
    <section
      className={`flex flex-col gap-3 p-4 ${STATS_CARD_CLASS} ${className}`}
      data-testid={`stats-card-${slugifyTitle(title)}`}
    >
      <header className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <h3 className="text-sm font-medium text-slate-100">{title}</h3>
          {subtitle ? <p className="text-xs text-slate-400">{subtitle}</p> : null}
        </div>
        {action}
      </header>
      <div className="min-h-0 flex-1">{children}</div>
    </section>
  );
}
